import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useCallback, useMemo, useState } from 'react';
/**
 * Talon for Option.
 *
 * @param {number} props.attribute_id the id of the option
 * @param {function} props.onSelectionChange callback handler for when the option is clicked
 * @param {string} props.selectedValue the label of the selected option
 * @param {array} props.values an array containing possible values
 */

export var useOption = function useOption(props) {
  var attribute_id = props.attribute_id,
      onSelectionChange = props.onSelectionChange,
      selectedValue = props.selectedValue,
      values = props.values;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      selection = _useState2[0],
      setSelection = _useState2[1];

  var initialSelection = useMemo(function () {
    var initialSelection = {};
    var searchValue = selection || selectedValue;

    if (searchValue) {
      initialSelection = values.find(function (value) {
        return value.default_label === searchValue;
      }) || {};
    }

    return initialSelection;
  }, [selectedValue, selection, values]);
  var valuesMap = useMemo(function () {
    return new Map(values.map(function (value) {
      return [value.value_index, value.store_label];
    }));
  }, [values]);
  var selectedValueDescription = selection || initialSelection.default_label || 'None';
  var handleSelectionChange = useCallback(function (selection) {
    setSelection(valuesMap.get(selection));

    if (onSelectionChange) {
      onSelectionChange(attribute_id, selection);
    }
  }, [attribute_id, onSelectionChange, valuesMap]);
  return {
    handleSelectionChange: handleSelectionChange,
    initialSelection: initialSelection,
    selectedValueDescription: selectedValueDescription
  };
};